import { Component } from '@angular/core';
import { CardItemComponent } from '../../UI/card-item/card-item.component';
@Component({
  selector: 'app-static-card-paper',
  imports: [CardItemComponent],
  templateUrl: './static-card-paper.component.html',
  styleUrl: './static-card-paper.component.css'
})
export class StaticCardPaperComponent {


  cardItems: any[] =
    [
      {
        icon: 'Images/card1.jpg',
        name: '1. Start With Untimed Practice',
        discrption: 'Begin by working through past papers without time pressure. Focus on understanding question patterns and identifying gaps in your knowledge.'
      }
      ,
      {
        icon: 'Images/card2.jpg',
        name: '2. Mark Your Answers Honestly',
        discrption: 'Compare your responses with mark schemes and examiner-style solutions. Note exactly where marks are gained or lost so you can improve your technique.'
      },
      {
        icon: 'Images/card3.jpg',

        name: '3. Move to Timed Exam Conditions',
        discrption: 'When you’re ready, complete full past papers under real exam timing.'
      }
    ]
}
